<template>
    <div>
        <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="12">
                &nbsp;
                <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true" v-if="$isFullAdmin">{{$t('common.create')}}</el-button>
                <el-button icon="el-icon-download" @click="download" v-if="$isAdmin">{{$t('common.export')}}</el-button>
                <input type="file" @change="handleFileUpload" style="display: none;" ref="uploader" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                <el-button icon="el-icon-upload" @click="uploadConfirm" v-if="$isAdmin">{{$t('common.import')}}</el-button>
                <span style="margin-left: 15px;" v-if="$isAdmin">
                    <label>Edit Mode</label>
                    <el-switch v-on:change="handleCancelEditMode" v-model="isEditMode"></el-switch>
                    <el-button @click="saveEdited" v-if="isEditMode">{{$t('common.save')}}</el-button>
                </span>
            </el-col>
            <el-col :span="4">
                <product-selector v-model="filter.productId"></product-selector>
            </el-col>
            <el-col :span="8">
                <el-input v-model="filter.text" prefix-icon="el-icon-search"></el-input>
            </el-col>
        </el-row>
        <el-table size="mini" :data="parts" v-loading="loading" class="orders-table tablewithshading">
            <el-table-column prop="no" :label="$t('common.number')" width="100%">
                <template slot-scope="scope">
                    <div class="cell" v-if="!isEditMode">
                        {{scope.row.no}}
                    </div>
                    <div v-else>
                        <el-input v-model="scope.row.no"></el-input>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="description" :label="$t('common.description')" width="250">
                <template slot-scope="scope">
                    <div class="cell" v-if="!isEditMode">
                        {{$i18n.locale == 'en' ? scope.row.description : scope.row.descriptionFr}}
                    </div>
                    <div v-else>
                        <el-input v-model="scope.row.description"></el-input>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="extendedPriceRate" :label="$t('masters.extendedPriceRate')">
                <template slot-scope="scope">
                    <div class="cell" v-if="!isEditMode">
                        {{scope.row.extendedPriceRate == 2 ? '50%' : '35%'}}
                    </div>
                    <div v-else>
                        <el-select v-model="scope.row.extendedPriceRate">
                            <el-option label="35%" value="1"></el-option>
                            <el-option label="50%" value="2"></el-option>
                        </el-select>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="usPrice.listPrice" :label="$t('masters.usListPrice')">
                <template slot-scope="scope">
                    <div class="cell" v-if="!isEditMode">
                        {{scope.row.usPrice.listPrice}}
                    </div>
                    <div v-else>
                        <el-input v-model="scope.row.usPrice.listPrice"></el-input>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="usPrice.extendedPrice" :label="$t('masters.usExtendedPrice')"></el-table-column>
            <el-table-column prop="cdnPrice.listPrice" :label="$t('masters.cdnListPrice')">
                <template slot-scope="scope">
                    <div class="cell" v-if="!isEditMode">
                        {{scope.row.cdnPrice.listPrice}}
                    </div>
                    <div v-else>
                        <el-input v-model="scope.row.cdnPrice.listPrice"></el-input>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="cdnPrice.extendedPrice" :label="$t('masters.cdnExtendedPrice')"></el-table-column>
            <el-table-column prop="shippingMethod" :label="$t('masters.shipVia')"></el-table-column>
            <el-table-column prop="isAuthRequired" :label="$t('masters.authReq')">
                <template slot-scope="scope">
                    {{scope.isAuthRequired ? $t('common.yes') : $t('common.no')}}
                </template>
            </el-table-column>
            <el-table-column prop="countryOfOrigin" :label="$t('common.coo')"></el-table-column>
            <el-table-column :label="$t('common.operations')" fixed="right" width="132">
                <template slot-scope="scope">
                    <el-button size="mini" @click="editPart(scope.row.id)">
                        <i class="el-icon-edit"></i>
                    </el-button>
                    <el-button size="mini" type="danger" @click="deletePart(scope.row.id)" v-if="$isFullAdmin">
                        <i class="el-icon-delete"></i>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pager" v-if="total !== 0" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="15" layout="total, prev, pager, next" :total="total">
        </el-pagination>
        <el-dialog :title="$t('masters.errorsWhileImporting')" :visible.sync="showErrors" @close="closeDialog" width="60%" class="part-dialog" append-to-body :close-on-click-modal="false">
            <div v-html="errors"></div>
        </el-dialog>
        <create-update-part-dialog :partId="partToEdit" :visible="dialogVisible" @dialogClosed="editFinished" @save="appendPart"></create-update-part-dialog>
        <el-dialog :title="$t('masters.AreYouSureThatYouWantToImportParts')"
                   :visible.sync="importConfirmVisible"
                   width="50%"
                   :close-on-click-modal="false">
            <span>{{importConfirm.partsToUpdate}} {{$t('masters.partsWillBeUpdated')}}</span>
            <p>{{importConfirm.partsToDelete}} {{$t('masters.partsWillBeDeleted')}}</p>
            <p>{{importConfirm.newParts}} {{$t('masters.partsWillBeAdded')}}</p>
            <span slot="footer"
                  class="dialog-footer">
                <el-button @click="importConfirmVisible = false">{{$t('common.no')}}</el-button>
                <el-button type="primary"
                           @click="backup()">{{$t('common.yes')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import CreateUpdatePartDialog from "./CreateUpdatePartDialog";
import { ProductSelector } from "@/app/shared/components";
import api from "../api";

export default {
  name: "part-list",
  components: {
    CreateUpdatePartDialog,
    ProductSelector
  },
  data() {
    return {
      parts: [],
      loading: true,
      dialogVisible: false,
      partToEdit: null,
      filter: {
        productId: undefined,
        text: undefined
      },
      currentPage: 1,
      total: 0,
      showErrors: false,
      errors: undefined,
      isEditMode: false,
      importConfirmVisible: false,
      importConfirm: {
          partsToUpdate: 0,
          partsToDelete: 0,
          newParts: 0
      },
      files: [],
    };
  },
  created() {
    this.loadParts();
  },
  watch: {
    filter: {
      deep: true,
      handler: function(val) {
        this.loadParts();
      }
    }
  },
  methods: {
    download() {
      api.download(this.filter);
    },
    upload() {
        this.importConfirmVisible = false;
        api.upload(this.files.item(0)).then(response => {
            this.files = [];
            this.$refs["uploader"].value = "";
            if (response.data.success) {
                this.$notify({
                    title: this.$t('common.success'),
                    message: this.$t('common.partsSuccesfullyImported'),
                    type: "success"
                });
                this.loadParts();
            } else {
                this.showErrors = true;
                this.errors = response.data.errors;
            }
        });
    },
    handleFileUpload(event) {
      if (
        event.target.files.length > 0 &&
        event.target.files
          .item(0)
          .name.split(".")
          .pop() == "xlsx"
      ) {
          this.files = event.target.files;
          api.uploadConfirm(event.target.files.item(0)).then(response => {
              if (response.data.success) {
                  this.importConfirm.partsToUpdate = response.data.partsToUpdate;
                  this.importConfirm.partsToDelete = response.data.partsToDelete;
                  this.importConfirm.newParts = response.data.newParts;
                  this.importConfirmVisible = true;
              } else {
                  this.showErrors = true;
                  this.errors = response.data.errors;
              }
          });
      }
    },
    closeDialog() {
      this.showErrors = false;
      this.errors = undefined;
    },
    loadParts() {
      this.loading = true;
      api
        .getParts(this.currentPage, this.filter.productId, this.filter.text)
        .then(response => {
          this.parts = response.data.items;
          this.parts.forEach(x => {
              x.extendedPriceRate = x.extendedPriceRate.toString();
              x.isAuthRequired = x.isAuthRequired ? true : false
          });
          this.total = response.data.total;
          this.loading = false;
        });
    },
    appendPart(event) {
      if (event.new) {
        this.parts.push(event.data);
        this.total += 1;
      } else {
        this.loadParts();
      }
    },
    handleCurrentChange(page) {
      if (this.isEditMode) {
        this.$confirm(
            this.$t('common.allUnsavedChangesWillBeLostContinue'),
          "Warning",
          {
            confirmButtonText: this.$t('common.OK'),
            cancelButtonText: this.$t('common.cancel'),
            type: "warning"
          }
        )
          .then(() => {
            this.currentPage = page;
            this.loadParts();
          })
          .catch(_ => {});
      } else {
        this.currentPage = page;
        this.loadParts();
      }
    },
    handleCancelEditMode() {
      if (!this.isEditMode) {
        this.$confirm(
          this.$t('common.allUnsavedChangesWillBeLostContinue'),
          "Warning",
          {
            confirmButtonText: this.$t('common.OK'),
            cancelButtonText: this.$t('common.cancel'),
            type: "warning"
          }
        )
          .then(() => {
            this.loadParts();
          })
          .catch(_ => {
            this.isEditMode = true;
          });
      }
    },
    editPart(id) {
      this.partToEdit = id;
      this.dialogVisible = true;
    },
    editFinished() {
      this.partToEdit = null;
      this.dialogVisible = false;
    },
    deletePart(id) {
        this.$confirm(this.$t('common.thisWillDeletePartContinue'), "Warning", {
        confirmButtonText: this.$t('common.OK'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      })
        .then(() => {
          api.deletePart(id).then(() => {
            this.loadParts();
            this.$message({
              type: "success",
              message: this.$t('common.deleteCompleted')
            });
          });
        })
        .catch(_ => {});
    },
    saveEdited() {
      if (!this.isEditMode) {
        return;
      }
      var self = this;
      this.$confirm(this.$t('common.areYouSure'), "Warning", {
        confirmButtonText: this.$t('common.OK'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      })
        .then(() => {
          api.saveParts(this.parts).then(response => {
            if (response.data.success) {
              self.$notify({
                title: this.$t('common.success'),
                  message: this.$t('common.partsWereSuccesfullySubmitted'),
                type: "success"
              });
              self.isEditMode = false;
            } else {
              response.data.errors.forEach(error => {
                self.$notify({
                  title: "Error",
                  message: error,
                  type: "error"
                });
              });
            }
          });
        })
        .catch(_ => {});
      },
      uploadConfirm() {
          this.$refs["uploader"].click();
      },
      backup() {
          api.backup().then(response => {
              this.upload();
          });
      }
  }
};
</script>



// WEBPACK FOOTER //
// ClientApp/app/masters/parts/components/PartList.vue